const func = function($btn) {
	var self = this,
		$text = $btn.find('span:not(.spinner-border)'),
		text = $text.text();

	this.enable = () => {
		$btn.prop('disabled', false);
	};

	this.disable = () => {
		$btn.attr('disabled', true);
	};

	this.process = () => {
		$btn.addClass('btn-processing');
		self.disable();
	};

	this.processed = () => {
		$btn.removeClass('btn-processing');
		self.enable();
	};

	this.text = $txt => {
		$text.text($txt);
	};

	this.resetText = () => {
		$text.text(text);
	};

	this.data = ($key, $val) => {
		if ($val) {
			$btn.attr('data-' + $key, $val);
		}
		return $btn.attr('data-' + $key);
	};
};

export default func;
